import { START_SEND_CONTACT_US } from '../types';

export const sendContactUs = payload => ({
    type: START_SEND_CONTACT_US,
    payload
})